import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const points = [
  'Compare trusted local HVAC professionals',
  'Instant replacement cost estimates',
  'Louisiana climate-specific guidance',
  'No sales pressure — just clear information',
];

const TrustBuilder = () => {
  return (
    <section className="py-16 bg-slate-50" data-testid="trust-builder-section">
      <div className="max-w-4xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h2
              className="text-3xl font-bold text-[#0F172A] mb-6"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Why Homeowners Use NOLA HVAC Connect
            </h2>
            <ul className="space-y-4 mb-8">
              {points.map((point, i) => (
                <li key={i} className="flex items-start gap-3" data-testid={`trust-point-${i}`}>
                  <CheckCircle className="w-5 h-5 text-[#0EA5E9] flex-shrink-0 mt-0.5" />
                  <span className="text-slate-600">{point}</span>
                </li>
              ))}
            </ul>
            <a href="/instant-hvac-estimate-new-orleans">
              <Button
                className="bg-[#F97316] hover:bg-[#EA580C] text-white font-bold py-3 px-6 rounded-full"
                data-testid="trust-builder-cta"
              >
                Get Your Free Estimate
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </a>
          </div>

          <div className="bg-white rounded-2xl p-8 border border-slate-200">
            <div className="space-y-6">
              <div className="text-center">
                <p className="text-4xl font-bold text-[#0EA5E9]" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  10+
                </p>
                <p className="text-slate-500 text-sm">Cities Served Across Louisiana</p>
              </div>
              <div className="h-px bg-slate-100" />
              <div className="text-center">
                <p className="text-4xl font-bold text-[#F97316]" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  Free
                </p>
                <p className="text-slate-500 text-sm">Instant Estimates — No Obligation</p>
              </div>
              <div className="h-px bg-slate-100" />
              <div className="text-center">
                <p className="text-4xl font-bold text-[#0F172A]" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  24/7
                </p>
                <p className="text-slate-500 text-sm">Online Access to HVAC Resources</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBuilder;
